import React from 'react'
import "./Testimonials.css"

const Testimonials = () => {
    return (
        <img src="/img/Testimonials.png" className="w-100" alt="" />
    )
}

export default Testimonials

